import Container from '@components/ui/layout/Container'
import { motion, MotionValue, useTransform } from 'framer-motion'
import React, { FC, useEffect, useState } from 'react'
import { HowItWorksSingleton } from '__generated__/sanity'
import { Layer } from './Layer'
import * as styles from './styles'

type PhotosProps = {
  images: HowItWorksSingleton['fields']['hero']['images']
  status: 'visible' | 'hidden'
  scrollY: MotionValue<number>
}

export const Photos: FC<PhotosProps> = ({ images, status, scrollY }) => {
  const [windowHeight, setWindowHeight] = useState<number | null>(null)
  const [windowWidth, setWindowWidth] = useState<number | null>(null)
  const [orientation, setOrientation] = useState<'landscape' | 'portrait'>(null)
  const transformDistance = orientation === 'landscape' ? windowHeight / 20 : windowWidth / 20
  const transform = useTransform(
    scrollY,
    [0, windowHeight * 0.15],
    [
      'translate3d(0px, 0px, 0px) skew(0deg, 0deg)',
      `translate3d(-${transformDistance}px, ${transformDistance * 2}px, 0px) skew(0deg, 10deg)`,
    ]
  )

  useEffect(() => {
    calculateValues()

    window.addEventListener('resize', calculateValues)

    return () => {
      window.removeEventListener('resize', calculateValues)
    }
  }, [])

  return (
    <div
      className={styles.container3d}
      data-visibility={status}
      style={{ margin: `${transformDistance * 2}px 0` }}
    >
      <Container className={styles.container}>
        <motion.div className={styles.layers} style={{ transform }}>
          {images.map((photo, index) => (
            <Layer
              key={index}
              scrollY={scrollY}
              windowHeight={windowHeight}
              windowWidth={windowWidth}
              index={images.length - 1 - index}
              source={photo.image.asset}
            />
          ))}
        </motion.div>
      </Container>
    </div>
  )

  function calculateValues() {
    if (typeof window !== undefined) {
      setWindowHeight(window.innerHeight)
      setWindowWidth(window.innerWidth)
      setOrientation(
        window.innerWidth < 1100 && window.innerHeight > window.innerWidth
          ? 'portrait'
          : 'landscape'
      )
    }
  }
}
